import * as React from 'react';
import {useEffect} from 'react';
import {withRouter, WithRouterProps} from 'react-router';
import * as _ from 'lodash';
export interface PromptProps {
  when: boolean;
  message?: string;
}

const Prompt: React.FunctionComponent<PromptProps> = ({
  when,
  message,
  router,
  routes,
}: PromptProps & WithRouterProps) => {
  useEffect(() => {
    const callback = (event?: BeforeUnloadEvent) => {
      if (when) {
        if (event) {
          event.returnValue = message;
        }
        return message;
      }
    };
    window.addEventListener('beforeunload', callback);
    if (router) {
      router.setRouteLeaveHook(_.last(routes), () => callback());
    }
    return () => {
      window.removeEventListener('beforeunload', callback);
    };
  }, [when, message]);
  return null;
};

Prompt.defaultProps = {
  message:
    'You have unsaved changes that will be lost if you decide to continue. Are you sure you want to leave this page?',
};

export default React.memo(withRouter(Prompt));
